import angular from 'angular'
import permissionOrgTree from './permissionOrgTree'

export default angular
    .module('app.permissionOrgTree', [])
    .directive('permissionOrgTree', permissionOrgTree)
    .name



// WEBPACK FOOTER //
// ./src/components/permissionOrgTree/index.js